import React from 'react';
import { Input } from 'reactstrap';
import Editable from './Editable';
import { newId } from '../helpers/GenericHelpers';

export default class EditableDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  getOptions() {
    return this.props.options || [];
  }

  handleChange = (e) => {
    this.setState({
      value: e.target.value,
    });
  }

  handleSubmit = (e) => {
    this.props.update(this.props.id, this.props.name, this.state.value);
    return 'submit';
  }

  display = () => {
    const item = this.getOptions().find(opt => opt.value === this.props.value);
    return item ? item.label : null;
  }

  render() {
    return (<Editable
      text={this.display()}
      submit={this.handleSubmit}
      itemRef={this.props.name}
    >
      <Input
        onChange={this.handleChange}
        key={this.state.inputKey}
        type="select"
        name="select"
        defaultValue="default"
      >
        <option key="default" value="default">
          {this.props.defaultText || 'Select ...'}
        </option>
        {this.getOptions().map((opt, index) => (<option key={`opt${index}`} value={opt.value}>
          {opt.label}
        </option>))}
      </Input>
    </Editable>);
  }
}
